import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../Components/ModelContainer";
import { actions } from "../../../../Redux";
import DatePicker from "react-datepicker";
import Select from "react-select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorContainer from "../../../Components/ErrorContainer";

const Transfer = (params) => {
  let orderTransferData = useSelector(
    (state) => state.orderSettingReducer.order_transfer_data
  );
  const editAccountDetails = useSelector(
    (state) => state.orderSettingReducer.editAccountDetails
  );

  const dispatch = useDispatch();
  const [transferType, setTransferType] = useState(0);
  const [effectiveDate, setEffectiveDate] = useState(null);
  const [deactivationDate, setDeactivationDate] = useState(null);
  const [secondaryAccounts, setSecondaryAccounts] = useState("");
  const [addAccountModal, setAddAccountModal] = useState(false);
  const [editAccountModal, setEditAccountModal] = useState(false);

  // step 1 create schema
  const accountModalSchema = yup.object({
    entity_id: yup.string().required(),
    eligible_transfer_directions: yup.string().required(),
    account_id: yup.array().nullable().required(),
    effective_date: yup.string().nullable().required(),
    deactivation_date: yup.string().nullable().required(),
    inventory_transfer_setting_id: yup.string().required(),
  });
  const editModalSchema = yup.object({
    entity_id: yup.number(),
    eligible_transfer_directions: yup.number(),
    account_id: yup.array().nullable(),
    effective_date: yup.string(),
    deactivation_date: yup.string(),
    inventory_transfer_setting_id: yup.string(),
  });
  // step 2 create default values
  const addAccountModalDefaultState = {
    entity_id: "",
    eligible_transfer_directions: "",
    account_id: "",
    effective_date: null,
    deactivation_date: null,
    inventory_transfer_setting_id: orderTransferData?.userId,
  };

  // step 3 create useForm hook
  const {
    register: addAccountRegister,
    formState: { errors: addAccountErrors },
    handleSubmit: addAccountSubmit,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(accountModalSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: addAccountModalDefaultState,
  });

  const editAccountModalDefaultState = {
    entity_id: editAccountDetails?.entity?.entity_id,
    eligible_transfer_directions:
      editAccountDetails?.entity?.eligible_transfer_directions,
    account_id: Array.isArray(editAccountDetails?.entity?.account_id)
      ? [...editAccountDetails?.entity?.account_id]
      : [editAccountDetails?.entity?.account_id],
    effective_date: editAccountDetails?.entity?.effective_date || null,
    deactivation_date: editAccountDetails?.entity?.deactivation_date || null,
    inventory_transfer_setting_id: orderTransferData?.userId,
  };

  // edit accountModal form hook
  const {
    register: editAccountRegister,
    formState: { errors: editAccountErrors },
    handleSubmit: editAccountSubmit,
    reset: editReset,
    setValue: editSetValue,
  } = useForm({
    resolver: yupResolver(editModalSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: editAccountModalDefaultState,
  });

  // multiModal handle
  function handleOptions(selectedOption, recipients, setRecipients) {
    const selectAll = selectedOption.find((option) => option.value === "");
    if (selectAll) {
      if (
        recipients?.length ===
        orderTransferData?.secondaryAccounts.length - 1
      ) {
        setRecipients("");
        setValue("account_id", " ");
      } else setRecipients(orderTransferData?.secondaryAccounts.slice(1));
    } else {
      if (selectedOption.length === 0) {
        selectedOption = "";
        setValue("account_id", " ");
      }
      console.log(selectedOption);
      setRecipients(selectedOption);
    }
  }

  // update addAccountMdal account id when secondaryAccount changes
  useEffect(() => {
    if (secondaryAccounts === "") return;
    const secondaryAccountsId = secondaryAccounts?.map((el) => el.value);
    setValue("account_id", secondaryAccountsId);
  }, [secondaryAccounts]);

  // get transfer data when page loads
  useEffect(() => {
    dispatch(actions.getOrderTransferData());
  }, []);

  // updating edit modal effects when editAccountDetails changes
  useEffect(() => {
    // update data for post api
    editReset(editAccountModalDefaultState);
    setDeactivationDate(
      new Date(editAccountModalDefaultState.deactivation_date)
    );
    setEffectiveDate(new Date(editAccountModalDefaultState.effective_date));
  }, [editAccountDetails]);

  const toggleAddAccountModal = () => {
    reset(addAccountModalDefaultState);
    setSecondaryAccounts("");
    orderTransferData.secondaryAccounts = [];
    setAddAccountModal(!addAccountModal);
  };

  const toggleEditAccountModal = () => {
    setEditAccountModal(!editAccountModal);
  };

  const sumbitAddAccount = (data) => {
    setAddAccountModal(!addAccountModal);
    dispatch(actions.addTransferAccount(data));
  };

  const submitEditAccount = (data) => {
    delete data.account_id;
    setEditAccountModal(!editAccountModal);
    dispatch(
      actions.editTransferAccount({
        id: editAccountDetails?.entity.id,
        ...data,
      })
    );
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 order-tranfer-settings chart-of-accounts">
          <div className="container px-0">
            <div className="row employeeSettingSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">Transfer Type</h4>
                  <div className="d-flex w-100 pt-0">
                    <ul class="mgt-type col-12">
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>None</h4>
                            <article>
                              <p>
                                If selected, all ability to closely track
                                incoming and outgoing inventory between accounts
                                within a given group’s shared entity will not be
                                available.
                              </p>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="radio"
                              name="data[OrderTransferSetting][OrderTransferSettingId]"
                              id="OrderTransferSettingId0"
                              value="0"
                              checked={transferType == 0 ? true : false}
                            />
                            <label
                              onClick={() => {
                                setTransferType(0);
                              }}
                              for="OrderTransferSettingId0"
                            >
                              0
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Enable Transfers</h4>
                            <article>
                              <p>
                                The system will be enabled to allow users to
                                select which linked entities are available for
                                transfer and what direction of transfer is
                                authorized. Once the links are established,
                                transfers, like orders, can be created,
                                seamlessly communicated between accounts,
                                confirmed, and GL entries will be automatically
                                generated.
                              </p>
                              <h5>
                                Only available when the account has one or more
                                Eligible Transfer Accounts
                              </h5>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="radio"
                              name="data[OrderTransferSetting][OrderTransferSettingId]"
                              id="OrderTransferSettingId1"
                              value="1"
                              checked={transferType == 1 ? true : false}
                            />
                            <label
                              onClick={() => {
                                // updateAddModal(
                                //   "inventory_transfer_setting_id",
                                //   1
                                // );
                                setTransferType(1);
                              }}
                              for="OrderTransferSettingId1"
                            >
                              1
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="inner-content row mx-0 order-tranfer-settings chart-of-accounts">
          <div className="container px-0">
            <div className="row employeeSettingSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">
                    Eligible Transfer Accounts
                  </h4>
                  <div className="d-flex w-100 pt-0">
                    <ul class="mgt-type col-12">
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>None</h4>
                            <article>
                              <p>
                                If selected, all ability to closely track
                                incoming and outgoing inventory between accounts
                                within a given group’s shared entity will not be
                                available.
                              </p>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="radio"
                              name="data[OrderTransferSetting][OrderTransferSettingId]"
                              id="OrderTransferSettingId0"
                              value="0"
                              checked
                            />
                            <label
                              // onClick={() => setTransferType(0)}
                              for="OrderTransferSettingId0"
                            >
                              0
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="col-set">
                          <div class="none-sec">
                            <h4>Enable Transfers</h4>
                            <article>
                              <p>
                                The system will be enabled to allow users to
                                select which linked entities are available for
                                transfer and what direction of transfer is
                                authorized. Once the links are established,
                                transfers, like orders, can be created,
                                seamlessly communicated between accounts,
                                confirmed, and GL entries will be automatically
                                generated.
                              </p>
                              <h5>
                                Only available when the account has one or more
                                Eligible Transfer Accounts
                              </h5>
                            </article>
                          </div>
                          <div class="radio-cust">
                            <input
                              type="radio"
                              name="data[OrderTransferSetting][OrderTransferSettingId]"
                              id="OrderTransferSettingId1"
                              value="1"
                            />
                            <label
                              // onClick={() => setTransferType(1)}
                              for="OrderTransferSettingId1"
                            >
                              1
                            </label>{" "}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/*  */}
        <div class="row mx-0 mt-4">
          <div class="container px-0">
            <div class="shadowclass mt-0">
              <h4 className="event-alert w-100">Eligible Transfer Settings</h4>
              <div class="table-responsive">
                <table class="checklist-table remove-space inventory_table">
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th class="col-2">Account # 1</th>
                      <th class="col-2">Eligible Transfer Directions</th>
                      <th>Account # 2</th>
                      <th>Effective Date</th>
                      <th> Deactivation Date</th>
                      <th class="action-td">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderTransferData?.data?.inventory_transfer_setting_entity?.map(
                      (acc) => {
                        return (
                          <tr>
                            <span
                              class={
                                acc.status === 1 ? "green_tag" : "bordered_tag"
                              }
                            >
                              {" "}
                              {acc.status === 1 ? "Active" : "Inactive"}
                            </span>
                            <td>
                              {" "}
                              <strong> {acc.supplier.account_name} </strong>
                            </td>

                            {acc.eligible_transfer_directions === 1 && (
                              <td>Incoming From</td>
                            )}
                            {acc.eligible_transfer_directions === 2 && (
                              <td>Outgoing To</td>
                            )}
                            {acc.eligible_transfer_directions === 3 && (
                              <td>Incoming From and Outgoing To</td>
                            )}
                            <td>
                              <strong>{acc.second_account.account_name}</strong>
                            </td>
                            <td>{acc.effective_date}</td>
                            <td>{acc.deactivation_date}</td>
                            <td class="d-flex">
                              <a
                                onClick={() => {
                                  dispatch(
                                    actions.getTransferAccountEditDetails(
                                      acc.id
                                    )
                                  );
                                  toggleEditAccountModal();
                                }}
                                role="button"
                                class="circle_icon edit_tooltip editAccountPm"
                              >
                                <i class="iconSprites edit-icon"></i>
                              </a>
                              <a
                                onClick={() => {
                                  dispatch(
                                    actions.updateTransferAccountStatus({
                                      id: acc.id,
                                      status:
                                        acc.status === 1
                                          ? "inactive"
                                          : "active",
                                    })
                                  );
                                }}
                                role="button"
                                class={`circle_icon pwr_tooltip ${
                                  acc.status === 1 ? "on" : ""
                                } `}
                              >
                                <i class="iconSprites pwr-icon"></i>
                              </a>{" "}
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
                <div class="my-3">
                  <button
                    class="btn green-btn-revert add-plus"
                    id="addCount"
                    type="button"
                    onClick={() => {
                      setEffectiveDate(null);
                      setDeactivationDate(null);
                      toggleAddAccountModal();
                    }}
                  >
                    <i class="i-icon"> </i> Add Account
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*  */}
        <div class="row mx-0">
          <div class="container px-0 d-flex col-12">
            <div class="btns col-4 d-flex justify-content-end py-4 col-12">
              <button
                onClick={() => {
                  console.log("jfdjew");
                  dispatch(
                    actions.postOrderTransferData({
                      transfer_type: transferType.toString(),
                    })
                  );
                }}
                id=""
                type="Submit"
              >
                Save
              </button>
              <button id="cancel" type="button">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Add account modal */}
      <ModelContainer
        title="Add Entities"
        open={addAccountModal}
        closeModal={toggleAddAccountModal}
        // submitModal={sumbitAddAccount}
        submitModal={addAccountSubmit(sumbitAddAccount)}
      >
        <form id="form-1">
          <div className="form-list">
            <ul className="px-0">
              {/* account 1 */}
              <li>
                <label className="required"> Account # 1 </label>
                <div className="input-wrap select-div">
                  <select
                    {...addAccountRegister("entity_id")}
                    name="entity_id"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === null) return;
                      setSecondaryAccounts("");
                      dispatch(actions.getSecondAccounts({ id: value }));
                    }}
                  >
                    <option value={""}>Select Account</option>
                    {orderTransferData?.accounts.map((el) => (
                      <option value={el.value}>{el.label}</option>
                    ))}
                  </select>
                  <ErrorContainer errors={addAccountErrors} name="entity_id" />
                </div>
              </li>
              {/* eligible transfer directions */}
              <li>
                <label className="required">
                  {" "}
                  Eligible Transfer Directions{" "}
                </label>
                <div className="input-wrap select-div">
                  <select
                    {...addAccountRegister("eligible_transfer_directions")}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === null) return;
                    }}
                  >
                    <option value=""> Select </option>
                    {orderTransferData?.eligible_transfer_arr.map((el) => (
                      <option value={el.value}>{el.label}</option>
                    ))}
                  </select>
                  <ErrorContainer
                    errors={addAccountErrors}
                    name="eligible_transfer_directions"
                  />
                </div>
              </li>
              {/* accounts 2 */}
              <li>
                <label className="required"> Account # 2 </label>
                <div className="input-wrap ">
                  <Select
                    isMulti
                    value={secondaryAccounts}
                    options={orderTransferData?.secondaryAccounts}
                    onChange={(selectedOption) => {
                      handleOptions(
                        selectedOption,
                        secondaryAccounts,
                        setSecondaryAccounts
                      );
                    }}
                  />
                  <ErrorContainer errors={addAccountErrors} name="account_id" />
                </div>
              </li>
              {/* effective date */}
              <li>
                <label className="required">Effective Date </label>
                <DatePicker
                  {...addAccountRegister("effective_date")}
                  selected={effectiveDate}
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => {
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();

                    setValue("effective_date", `${year}-${month}-${day}`);

                    console.log(day, month, year);
                    setEffectiveDate(date);
                  }}
                />
                <ErrorContainer
                  errors={addAccountErrors}
                  name="effective_date"
                />
              </li>
              {/* deActivation date */}
              <li>
                <label className="required">Deactivation Date </label>
                <DatePicker
                  {...addAccountRegister("deactivation_date")}
                  selected={deactivationDate}
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => {
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();

                    setValue("deactivation_date", `${year}-${month}-${day}`);

                    setDeactivationDate(date);
                  }}
                />
                <ErrorContainer
                  errors={addAccountErrors}
                  name="deactivation_date"
                />
              </li>
            </ul>
          </div>
        </form>
      </ModelContainer>

      {/* Edit account modal */}
      <ModelContainer
        title="Edit Entities"
        open={editAccountModal}
        closeModal={toggleEditAccountModal}
        submitModal={editAccountSubmit(submitEditAccount)}
      >
        <form>
          <div className="form-list">
            <ul className="px-0">
              {/*edit account 1 */}
              <li>
                <label className="required"> Account # 1 </label>
                <div className="input-wrap select-div">
                  <select
                    disabled
                    {...editAccountRegister("entity_id")}
                    style={{ color: "rgb(170, 170, 170)" }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === null) return;
                      dispatch(actions.getSecondAccounts({ id: value }));
                    }}
                  >
                    <option value={null}> Select Account </option>
                    {editAccountDetails?.accounts.map((el) => {
                      return (
                        <option
                          selected={
                            editAccountModalDefaultState.entity_id == el.value
                              ? true
                              : false
                          }
                          value={el.value}
                        >
                          {el.label}
                        </option>
                      );
                    })}
                  </select>
                  <ErrorContainer errors={editAccountErrors} name="entity_id" />
                </div>
              </li>
              {/*edit eligible transfer directions */}
              <li>
                <label className="required">
                  {" "}
                  Eligible Transfer Directions{" "}
                </label>
                <div className="input-wrap select-div">
                  <select
                    {...editAccountRegister("eligible_transfer_directions")}
                    onChange={(e) => {
                      const value = e.target.value;
                      editSetValue("eligible_transfer_directions", value);
                    }}
                  >
                    <option value=""> Select </option>
                    {orderTransferData?.eligible_transfer_arr.map((el) => {
                      return (
                        <option
                          selected={
                            editAccountModalDefaultState.eligible_transfer_directions ==
                            el.value
                              ? true
                              : false
                          }
                          value={el.value}
                        >
                          {el.label}
                        </option>
                      );
                    })}
                  </select>
                  <ErrorContainer
                    errors={editAccountErrors}
                    name="eligible_transfer_directions"
                  />
                </div>
              </li>
              {/*edit accounts 2 */}
              <li>
                <label className="required"> Account # 2 </label>
                <div className="input-wrap">
                  <Select
                    {...editAccountRegister("account_id")}
                    isMulti
                    isDisabled
                    // value={orderTransferData?.secondaryAccounts?.filter(
                    //   (el) =>
                    //     editAccountModalDefaultState.account_id === el.value
                    // )}
                    value={editAccountDetails?.second_account}
                    options={orderTransferData?.secondaryAccounts}
                    onChange={(selectedOption) => {
                      handleOptions(
                        selectedOption,
                        secondaryAccounts,
                        setSecondaryAccounts
                      );
                    }}
                  />
                  <ErrorContainer
                    errors={editAccountErrors}
                    name="account_id"
                  />
                </div>
              </li>
              {/* effective date */}
              <li>
                <label className="required">Effective Date </label>
                <DatePicker
                  {...editAccountRegister("effective_date")}
                  selected={effectiveDate}
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => {
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();
                    editSetValue("effective_date", `${year}-${month}-${day}`);
                    setEffectiveDate(date);
                  }}
                />
                <ErrorContainer
                  errors={editAccountErrors}
                  name="effective_date"
                />
              </li>
              {/* deActivation date */}
              <li>
                <label className="required">Deactivation Date </label>
                <DatePicker
                  selected={deactivationDate}
                  dateFormat="dd/MM/yyyy"
                  {...editAccountRegister("deactivation_date")}
                  onChange={(date) => {
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();
                    editSetValue(
                      "deactivation_date",
                      `${year}-${month}-${day}`
                    );

                    setDeactivationDate(date);
                  }}
                />
                <ErrorContainer
                  errors={editAccountErrors}
                  name="deactivation_date"
                />
              </li>
            </ul>
          </div>
        </form>
      </ModelContainer>
    </UserInterface>
  );
};
export default Transfer;
